// jQuery plugins
import './globals/jquery';
import 'jquery-trend'; // eslint-disable-line
import 'jquery-revealer'; // eslint-disable-line

// Global imports
import './globals/flickity-ios-fix';

// Responsive Images
import 'intersection-observer'; // eslint-disable-line
import rimg from 'rimg-shopify'; // eslint-disable-line
import orimg from 'rimg'; // bc

// Template imports
import Account from './templates/Account';
import Contact from './templates/Contact';
import Page from './templates/Page';
import GiftCard from './templates/GiftCard';

// Section imports
import Sections from './Sections';
import StaticAnnouncement from './sections/StaticAnnouncement';
import StaticSectionHeader from './sections/StaticSectionHeader';
import StaticSectionFooter from './sections/StaticSectionFooter';
import StaticArticle from './sections/StaticArticle';
import StaticBlog from './sections/StaticBlog';
import StaticCart from './sections/StaticCart';
import StaticCollection from './sections/StaticCollection';
import StaticPassword from './sections/StaticPassword';
import StaticProduct from './sections/StaticProduct';
import StaticSearch from './sections/StaticSearch';
import DynamicBlogPosts from './sections/DynamicBlogPosts';
import StaticHighlightsBanners from './sections/StaticHighlightsBanners';
import StaticSlideshow from './sections/StaticSlideshow';
import DynamicPromoBlocks from './sections/DynamicPromoBlocks';
import DynamicMenuList from './sections/DynamicMenuList';
import DynamicTwitterFeed from './sections/DynamicTwitterFeed';
import DynamicInstagramFeed from './sections/DynamicInstagramFeed';
import DynamicFeaturedCollection from './sections/DynamicFeaturedCollection';
import DynamicSearch from './sections/DynamicSearch';
import DynamicRichText from './sections/DynamicRichText';
import DynamicVideo from './sections/DynamicVideo';
import DynamicNewsletter from './sections/DynamicNewsletter';
import PXSMap from 'pxs-map'; // eslint-disable-line

rimg.init();

const sections = new Sections();

// PFS
window.bcSections = Sections;
window.bcStaticCollection = StaticCollection;
window.bcImages = orimg;

sections.register('static-header', section => new StaticSectionHeader(section));
sections.register('static-announcement', section => new StaticAnnouncement(section));
sections.register('static-footer', section => new StaticSectionFooter(section));
sections.register('static-article', section => new StaticArticle(section));
sections.register('static-blog', section => new StaticBlog(section));
sections.register('static-cart', section => new StaticCart(section));
sections.register('static-collection', section => new StaticCollection(section));
sections.register('static-password', section => new StaticPassword(section));
sections.register('static-product', section => new StaticProduct(section));
sections.register('static-search', section => new StaticSearch(section));
sections.register('dynamic-blog-posts', section => new DynamicBlogPosts(section));
sections.register('static-highlights-banners', section => new StaticHighlightsBanners(section));
sections.register('static-slideshow', section => new StaticSlideshow(section));
sections.register('dynamic-promo-mosaic', section => new DynamicPromoBlocks(section));
sections.register('dynamic-promo-grid', section => new DynamicPromoBlocks(section));
sections.register('dynamic-menu-list', section => new DynamicMenuList(section));
sections.register('dynamic-twitter-feed', section => new DynamicTwitterFeed(section));
sections.register('dynamic-instagram-feed', section => new DynamicInstagramFeed(section));
sections.register('dynamic-featured-collection', section => new DynamicFeaturedCollection(section));
sections.register('dynamic-featured-product', section => new StaticProduct(section));
sections.register('dynamic-rich-text', section => new DynamicRichText(section));
sections.register('dynamic-search', section => new DynamicSearch(section));
sections.register('dynamic-video', section => new DynamicVideo(section));
sections.register('pxs-newsletter', section => new DynamicNewsletter(section));
sections.register('pxs-map', section => new PXSMap(section));

if ($('body.giftcard').length) {
  new GiftCard();
}
//

new Account();
new Contact();
new Page();

// Flickity hot fix until Webkit fixes this bug: https://bugs.webkit.org/show_bug.cgi?id=184250#c31
$(document).on('dragStart.flickity', '.flickity-enabled', () => {
  document.ontouchmove = (e) => {
      e.preventDefault();
  }
});

$(document).on('dragEnd.flickity', '.flickity-enabled', () => {
    document.ontouchmove = () => {
        return true;
    }
});


// Sold Out (Contact Order) form 
let formOpen = document.querySelector('.contact-order-form-button')

if (formOpen !== null) {
  let formClose = document.querySelector('.close-form-popup'),
    formOverlay = document.querySelector('.form-overlay'),
    formPopup = document.querySelector('.contact-order-form-popup'),
    formSoldOutShow = document.querySelector('.sold-out-contact-order'),
    productAddToCart = document.querySelectorAll('.product-page-addToCart'),
    productSKU = document.querySelector('.product-details [data-product-sku]'),
    productSelector = document.querySelector('.product-main [data-product-options-container] .form-field-select'),
    productSKU_input = document.querySelector('.contact-order-form .form-field-row.hidden .product-sku');
  
  formOpen.addEventListener('click', () => {
    formPopup.classList.add('open')
  })

  formClose.addEventListener('click', () => {
    formPopup.classList.remove('open')
  })

  formOverlay.addEventListener('click', () => {
    formPopup.classList.remove('open')
  })

  window.onload = () => {
    if (!formSoldOutShow.classList.contains('hidden')) {
      productAddToCart.forEach((btn) => {
        btn.classList.add('hidden')
      })
      // Get Product SKU value
      productSKU_input.value = productSKU.textContent;
    }
  }
}